import { Card, Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import mark_email from "../../assets/images/mark_email.png";
import { PrimaryButton } from "../../common/Buttons";
import "./AppointmentCard.scss";

const AppointmentCard = () => {
  const { t } = useTranslation();
  return (
    <Card className="appointmet-card">
      <Grid container>
        <Grid item lg={7} md={6} sm={12} xs={12} className="outer">
          <Typography variant="h5">
            {t("app-req-msg-1")} <br /> {t("app-req-msg-2")}
          </Typography>
          <img src={mark_email} height="60px" width="60px" />
          <Typography>{t("app-req-msg-text")}</Typography>
          <div className="button-container">
            <PrimaryButton
              title={t("back")}
              padding="5px 30px"
              textTransform="initial"
            />
          </div>
        </Grid>
      </Grid>
    </Card>
  );
};

export default AppointmentCard;
